import { observer } from 'mobx-react-lite'
import { useRouteError } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import { JobRootViewContainer } from './JobRootViewContainer'

/**
 * Shows a job that failed to load in place of the job, so the navigation and
 * job list stay usable.
 */
export default observer(function JobRootErrorBoundaryContainer() {
  const error = useRouteError()
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return (
    <JobRootViewContainer
      rootVm={internal.jobRootViewModel}
      data={null}
      error={error}
    />
  )
})
